import React from "react";
import styles from "./Objective.module.css";

function Objective(props: any) {
  return (
    <section className={styles.Objective}>
      <h1>Summary</h1>
      <p className={styles.objectiveText}>
        Full-stack engineer who solves problems, not just tickets. 20+ years
        identifying gaps in products and ecosystems, building relationships
        across teams, and driving solutions - whether I'm writing the code or
        not. Early engineer at RelateIQ (acquired by Salesforce, $390M), founded
        developer advocacy at Airkit, and took founding engineer roles at
        multiple startups. Seeking senior/staff roles where strategic thinking
        and execution go hand-in-hand.
      </p>
    </section>
  );
}

export default Objective;
